import { FUNDING_SOURCE, loadScript, PayPalNamespace } from "@paypal/paypal-js"
import { payPalButtonCreateOrder } from "src/integrations/paypal/callbacks/createOrder"
import { payPalButtonOnApprove } from "src/integrations/paypal/callbacks/onApprove"
import { payPalButtonOnCancel } from "src/integrations/paypal/callbacks/onCancel"
import { payPalButtonOnClick } from "src/integrations/paypal/callbacks/onClick"
import { payPalButtonOnError } from "src/integrations/paypal/callbacks/onError"
import { payPalButtonOnShippingChange } from "src/integrations/paypal/callbacks/onShippingChange"
import { paypalLogPrefix } from "src/integrations/paypal/constants"
import { recordError } from "src/utilities/errorReporting"

let paypalPromise: Promise<PayPalNamespace | null> | undefined

async function loadPayPalScript() {
  const paypalClientId = process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID!

  if (!paypalClientId) {
    throw new Error("Please set NEXT_PUBLIC_PAYPAL_CLIENT_ID")
  }

  return loadScript({
    // https://developer.paypal.com/studio/checkout/standard/integrate#configure-script-parameters
    clientId: paypalClientId,
    currency: "EUR",
    enableFunding: "paypal" satisfies FUNDING_SOURCE,
    disableFunding:
      "applepay,bancontact,blik,boletobancario,card,credit,eps,giropay,ideal,itau,maxima,mercadopago,multibanco,mybank,oxxo,p24,paylater,payu,sepa,sofort,trustly,venmo,wechatpay,zimpler",
    components: "buttons",
    intent: "authorize",
    // debug: true,
  })
}

async function loadPayPalOnce() {
  if (!paypalPromise) {
    paypalPromise = loadPayPalScript()
  }
  return paypalPromise
}

let loading = false

export async function loadAndRenderPayPalButton(id: string) {
  if (loading) {
    return
  }

  try {
    loading = true

    const paypal = await loadPayPalOnce()

    if (!paypal) {
      throw new Error("Failed to load JS SDK")
    }
    if (!paypal.Buttons) {
      throw new Error("JS SDK is missing buttons component")
    }
    // if (!paypal.isFundingEligible?.("paypal")) {
    //   throw new Error("Funding not eligible")
    // }

    const component = await paypal.Buttons({
      // https://developer.paypal.com/studio/checkout/standard/integrate#configure-layout-buttons
      style: {
        shape: "pill",
        color: "gold",
        layout: "vertical",
        disableMaxWidth: true,
        height: 54,
        label: "paypal",
      },

      onClick: payPalButtonOnClick,
      createOrder: payPalButtonCreateOrder,

      // This function is deprecated, but onShippingAddressChange does not
      // yet support all of the features of onShippingChange.
      onShippingChange: payPalButtonOnShippingChange,

      onApprove: payPalButtonOnApprove,
      onCancel: payPalButtonOnCancel,
      onError: payPalButtonOnError,
    })

    if (document.querySelector(`#${id}`)) {
      component.render("#" + id)
    } else {
      console.warn(
        paypalLogPrefix,
        "Failed to render PayPal button.",
        "The element with id " + id + " does not exist.",
        "This can happen if the element was unmounted while loading the PayPal buttons.",
      )
    }
  } catch (error) {
    recordError(paypalLogPrefix + " Failed to render buttons", error)
  } finally {
    loading = false
  }
}
